var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAddLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148029",
    "data-name": "Rectangle 148029",
    width: 30,
    height: 30,
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invite",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11143",
    "data-name": "Group 11143",
    transform: "translate(3.456 1.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M5.742,14.05H5.5a5.075,5.075,0,0,1-3.764-1.675C-.375,10,.019,5.913.046,5.688.181,2.773,1.572,1.4,2.724.752A6.053,6.053,0,0,1,5.648,0h.086A6.061,6.061,0,0,1,8.658.765c1.133.645,2.518,2.021,2.65,4.923.068.732.3,4.435-1.7,6.687A5.088,5.088,0,0,1,5.835,14.05ZM5.7,12.137h.008c.053,0,.107.007.156.007a3.168,3.168,0,0,0,2.33-1.038C9.621,9.5,9.464,6.516,9.418,5.892A.281.281,0,0,1,9.4,5.8c-.143-3.14-2.1-3.845-3.711-3.885H5.64c-1.064,0-3.545.38-3.709,3.885v.068l-.008.013c-.02.2-.291,3.512,1.229,5.228a3.133,3.133,0,0,0,2.48,1.03Z",
    transform: "translate(5.268)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M10.585,12.1A25.8,25.8,0,0,1,.652,9.615.9.9,0,0,1,.292,9.16l-.008-.02A8,8,0,0,1,.007,6.713V6.55C.048,5.471.128,2.957,2.544,2.122l.033-.013H2.6A.058.058,0,0,1,2.63,2.1,14.96,14.96,0,0,0,6.849.168.984.984,0,0,1,7.392,0a.952.952,0,0,1,.549,1.729,16.467,16.467,0,0,1-4.822,2.2C2.07,4.313,1.947,5.458,1.913,6.611c0,.033-.008.067-.008.094V6.74a9.1,9.1,0,0,0,.088,1.438,22.937,22.937,0,0,0,8.668,2.041.946.946,0,0,1-.027,1.892A.109.109,0,0,1,10.585,12.1Z",
    transform: "translate(0 13.499)",
    fill: "#ff411a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M3.264,3.248A15.946,15.946,0,0,1,.409,1.736a.933.933,0,0,1-.393-.618A.919.919,0,0,1,.173.406.94.94,0,0,1,.952,0a.985.985,0,0,1,.543.17A13.841,13.841,0,0,0,3.854,1.438l.016.006a.872.872,0,0,1,.445.895,1,1,0,0,1-1.01.909Z",
    transform: "translate(13.648 13.5)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11143-2",
    "data-name": "Group 11143",
    transform: "translate(13.877 18.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_24",
    "data-name": "Union 24",
    d: "M3.672,8.27V5.537H.938a.936.936,0,1,1,0-1.873H3.672V.936a.937.937,0,0,1,1.873,0V3.665H8.271a.936.936,0,1,1-.008,1.873H5.545V8.27a.937.937,0,0,1-1.873,0Z",
    fill: "#ff411a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddLarge);
export default __webpack_public_path__ + "static/media/user-add-large.c81e511e.svg";
export { ForwardRef as ReactComponent };